import { Fragment } from "react";
import { useSelector } from "react-redux";
import PrivateLayout from "../../../components/layouts/PrivateLayout";
import Feed from "../feed/Feed";

function ProfileV2() {
  // Get user role and CPA status from Redux
  const { user } = useSelector((state) => state.auth);
  const userRole = user?.user_role;
  const cpaStatus = user?.account_status;
  // Check if user is CPA with non-active status
  const isCpaWithInactiveStatus = userRole === "CPA" && cpaStatus !== "AC";
  // Check if user is CPA with active status
  const isCpaWithActiveStatus = userRole === "CPA" && cpaStatus === "AC";

  return (
    <Fragment>
      {/* Pass false or omit loading on PrivateLayout if Feed handles its internal skeletons */}
      <PrivateLayout loading={false} fullsize={true}>
        {/* Main Content Area */}
        <div className="main-content-area feed-external-container">
          <Feed />
        </div>
      </PrivateLayout>
    </Fragment>
  );
}

export default ProfileV2;
